module.exports = __webpack_public_path__ + "static/media/bm-zbgis.d6adaed6.png";